import React from "react";
import Steps from "rc-steps";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";
import "rc-steps/assets/index.css";
import { STEP_TITLES } from "../constants";

const BookingStepper = ({ currentStep, isMobile, isTablet }) => {
  const direction = isMobile || isTablet ? "horizontal" : "vertical";

  // For mobile, only show current step label above stepper
  const currentStepLabel = STEP_TITLES[currentStep] || "";

  // Build steps with custom icons (numbers or checkmark for completed)
  const steps = STEP_TITLES.map((title, index) => {
    const isCompleted = index < currentStep;
    return {
      title,
      icon: isCompleted ? (
        <span className="public-client-booking-step-check">
          <Icon path={mdiCheck} />
        </span>
      ) : (
        <span className="public-client-booking-step-number">{index + 1}</span>
      ),
    };
  });

  // Determine wrapper class based on device
  let wrapperClass = "public-client-booking-stepper";
  if (isMobile) {
    wrapperClass += " public-client-booking-stepper--mobile";
  } else if (isTablet) {
    wrapperClass += " public-client-booking-stepper--tablet";
  } else {
    wrapperClass += " public-client-booking-stepper--desktop";
  }

  return (
    <div className={wrapperClass}>
      {/* Mobile: Show only current step label above */}
      {isMobile && (
        <div className="public-client-booking-stepper-mobile-label">
          {currentStepLabel}
        </div>
      )}
      <Steps current={currentStep} direction={direction} items={steps} />
    </div>
  );
};

export default BookingStepper;
